import { LoginResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const shopifyLogin = async (_shopId: string) => {
  let shopId = _shopId;
  if (!shopId.endsWith(".myshopify.com")) {
    shopId += ".myshopify.com";
  }
  const resp = await api.post<LoginResponseBodyType>("/v2/auth/shop", {
    shopId,
  });
  return resp.data;
};

export const useShopifyLogin = () => {
  return useMutation<LoginResponseBodyType, Error, string>({
    mutationFn: async (token: string) => shopifyLogin(token),
  });
};
